/**
 * Utility functions for window operations that can be easily mocked in tests
 */

export const windowUtils = {
  /**
   * Redirects to a URL using window.location.assign
   */
  redirectTo: (url: string): void => {
    window.location.assign(url);
  },

  /**
   * Opens a URL in a new window/tab
   */
  openInNewWindow: (
    url?: string,
    target = '_blank',
    features = 'noopener,noreferrer',
  ): Window | null => {
    if (!url) {
      return null;
    }
    return window.open(url, target, features);
  },

  /**
   * Gets the current pathname from window.location
   */
  getPathname: (): string => {
    return window.location.pathname;
  },

  /**
   * Gets the current search string from window.location
   */
  getSearch: (): string => {
    return window.location.search;
  },

  /**
   * Gets the current host from window.location
   */
  getHost: (): string => {
    return window.location.host;
  },

  /**
   * Gets the current href from window.location
   */
  getHref: (): string => {
    return window.location.href;
  },

  /**
   * Gets the current hostname from window.location
   */
  getHostname: (): string => {
    return window.location.hostname;
  },

  /**
   * Reloads the current page
   */
  reload: (): void => {
    window.location.reload();
  },

  /**
   * Gets the current origin from window.location
   */
  getOrigin: (): string => {
    return window.location.origin;
  },

  /**
   * Gets the current port from window.location
   */
  getPort: (): string => {
    return window.location.port;
  },

  /**
   * Gets the current protocol from window.location
   */
  getProtocol: (): string => {
    return window.location.protocol;
  },
};
